import { IGetters } from '@/interfaces/store.interfaces';
import { CopilotServiceApplication } from '@/application/copilot-service-application';
const getters: IGetters = {
	shouldShowChatUI: () => CopilotServiceApplication.Store.state.shouldShowChatUI,
	chatSessionId: () => CopilotServiceApplication.Store.state.chatSessionId,
	chatHistory: () => CopilotServiceApplication.Store.state.chatHistory,
	userSessions: () => CopilotServiceApplication.Store.state.userSessions,
	userNationalityCountryIso: () => CopilotServiceApplication.Store.state.userNationalityCountryIso,
	userCurrency: () => CopilotServiceApplication.Store.state.userCurrency,
	canLoadUserSession: () => CopilotServiceApplication.Store.state.canLoadUserSession,
	isSidebarOpen: () => CopilotServiceApplication.Store.state.isSidebarOpen,
	shouldShowFooter: () => CopilotServiceApplication.Store.state.shouldShowFooter,
	userId: () => CopilotServiceApplication.Store.state.userId,
	getBestfitCompletness: () => CopilotServiceApplication.Store.state.bestfitCompletness,
	getActiveStudyId: () => CopilotServiceApplication.Store.state.activeStudyId,
};

export default getters;
